import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import ComponentLayout from '../../../src/layouts/component-layout';
import anatomy from './images/anatomy.png';
export const _frontmatter = {
  "title": "Section",
  "description": "Use a Section to group and structure related content on a page."
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Anatomy`}</h2>
    <img src={anatomy} alt="The anatomy of the section component illustrates the various elements that make it up." />
    <ul>
      <li parentName="ul"><strong parentName="li">{`Container:`}</strong>{` Wraps the content to ensure proper alignment and responsiveness across different viewports.`}</li>
      <li parentName="ul"><strong parentName="li">{`Padding:`}</strong>{` Customizable padding at the top and bottom of the section to suit different content needs.`}</li>
      <li parentName="ul"><strong parentName="li">{`Background:`}</strong>{` Options to customize the background with colors or images.`}</li>
    </ul>
    <h2>{`Usage`}</h2>
    <p>{`The Section component is a versatile layout tool. It serves as a container that can be customized to fit various design needs.`}</p>
    <p>{`Use the Section component to create distinct blocks of related content within a page, enhancing both the structure and the layout. Use it to break up long pages into more digestible segments, making the content more approachable for users.`}</p>
    <h3>{`Content Grouping`}</h3>
    <p>{`Use the Section component to group related elements together, such as one or more subsections containing text, images, links and other compositions that share a common theme.`}</p>
    <h3>{`Semantics and headings`}</h3>
    <p>{`The Section component is a semantic element used to create a new section within a page. It should include a heading to title the section. You may use the `}<a parentName="p" {...{
        "href": "/brand/components/SectionIntro"
      }}>{`section intro component`}</a>{` or rely top-level components like Hero that already provide the required heading. Ensure that the heading level is appropriate for the content hierarchy.`}</p>
    <h3>{`Visual Separation`}</h3>
    <p>{`Use different backgrounds and paddings to visually differentiate different sections within a page, aiding in content hierarchy and navigation.`}</p>
    <h3>{`Grids and responsive design`}</h3>
    <p>{`The container maintains content margins and allows the use of the Grid to consistently align elements across different viewport sizes.`}</p>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/brand/components/SectionIntro"
        }}>{`SectionIntro`}</a>{`: to add a heading and optional description to the section.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/brand/components/Stack"
        }}>{`Stack`}</a>{`: to enable layout of its immediate children along the vertical or horizontal axis.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/brand/components/Grid"
        }}>{`Grid`}</a>{`: to create flexible and responsive grid-based layouts.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/brand/components/Box"
        }}>{`Box`}</a>{`: to applying one-off styles to an element.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      